import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询复杂道具列表
export const queryUeBlocks: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setUeBlocks', { ...state.list, loading: true });
    const res: IPageData = await $http.post('/v1/asset/prop/blockpagelist', payload);
    commit('setUeBlocks', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setUeBlocks', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询复杂道具详情
export const queryUeBlockDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setUeBlockDetail', { data: null, loading: true });
    const res = await $http.get(`/v1/asset/prop/${payload}/blockdetail`);
    commit('setUeBlockDetail', { data: res, loading: false });
  } catch (e) {
    commit('setUeBlockDetail', { data: null, loading: false });
  }
};

// 查询模块组装类型
export const queryBlockStructTypes: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setBlockStructTypes', { data: [], loading: true });
    const res = await $http.get('/common/chooseoptions/ModuleStructureType');
    commit('setBlockStructTypes', { data: res });
  } catch (e) {
    commit('setBlockStructTypes', { data: [] });
  }
};

// 查询控制件组装位置类型
export const queryLocationTypes: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setLocationTypes', { data: [], loading: true });
    const res = await $http.get('/common/chooseoptions/componentLocatingType');
    commit('setLocationTypes', { data: res });
  } catch (e) {
    commit('setLocationTypes', { data: [] });
  }
};

// 查询模块状态类型
export const queryBlockStatusTypes: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setBlockStatusTypes', { data: [], loading: true });
    const res: any[] = await $http.get('/common/chooseoptions/ModuleItemStatus');
    const data =  [{ optionKey: '', optionValue: '全部' } , ...res];
    commit('setBlockStatusTypes', { data });
  } catch (e) {
    commit('setBlockStatusTypes', { data: [] });
  }
};

// 查询摆放轴
export const queryBlockAxis: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setDigitalBlockAxis', { ...state.blockAxis, loading: true });
    const res = await $http.get('/common/chooseoptions/Axis');
    commit('setDigitalBlockAxis', { data: res });
  } catch (e) {
    commit('setDigitalBlockAxis', { data: [] });
  }
};

// 编辑复杂道具
export const editUeBlock: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/asset/prop/modifyblock', payload);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除
export const deleteUeBlock: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/v1/asset/prop/deleteblock', payload); // 删除
    await $http.post('/v1/asset/prop/resetcreatedblock', payload);  // 将入库状态还原为新建状态
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 上下架
export const shelfUeBlock: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/asset/prop/publishblock', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 批量刷新索引
export const refreshUeBlockIndex: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/model/type/item/batch/refresh', payload);
    await $http.post('/v1/asset/item/refresh', payload);
    store.commit('common/setToast', { visible: true, text: '索引刷新成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 更新缩略图
export const updateUeBlockThumb: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setUeBlockThumb', { ...state.thumb, loading: true });
    const res = await $http.post('/v1/asset/block/modifyimg', payload);
    commit('setUeBlockThumb', { data: res, loading: false });
  } catch (e) {
    commit('setUeBlockThumb', { data: null, loading: false });
  }
};

// 删除过滤配置
export const deleteUeBlockFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    await $http.post('/v1/asset/block/filterdelete', payload);
    return true;
  } catch (e) {
    return false;
  }
};

// 保存过滤配置
export const saveBlockFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    await $http.post('/v1/asset/block/filterbatchmodify', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } catch (e) {
    return;
  }
};
